"use client";

import { c as _c } from "react/compiler-runtime";
import type { QuickAction, QuickFlowContext } from "@/lib/chat/types";
import { getQuickActionsForContext } from "@/lib/chat/quick-actions";
import { QUICK_ACTION_BAR_CLASS, QUICK_ACTION_PILL_CLASS } from "@/components/chat/quickActionStyles";
interface ChatQuickActionsProps {
  onSelect: (message: string, action: string) => void;
  quickFlowContext?: QuickFlowContext | null;
  actions?: QuickAction[];
}

/**
 * Quick action buttons shown below the conversation.
 * When on a form page, shows step-specific actions that update on navigation.
 * Otherwise, shows default sell/buy/learn actions.
 */
export function ChatQuickActions(t0) {
  const $ = _c(11);
  const {
    onSelect,
    quickFlowContext,
    actions: t1
  } = t0;
  let t2;
  if ($[0] !== quickFlowContext || $[1] !== t1) {
    t2 = t1 === undefined ? getQuickActionsForContext(quickFlowContext ?? null) : t1;
    $[0] = quickFlowContext;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const actions = t2;
  const stepKey = quickFlowContext ? `${quickFlowContext.flow}-${quickFlowContext.step}` : "default";
  let t3;
  if ($[3] !== actions || $[4] !== onSelect) {
    let t4;
    if ($[6] !== onSelect) {
      t4 = action => <button key={action.key} type="button" onClick={() => onSelect(action.message, action.key)} className={QUICK_ACTION_PILL_CLASS}>{action.label}</button>;
      $[6] = onSelect;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = actions.map(t4);
    $[3] = actions;
    $[4] = onSelect;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[8] !== stepKey || $[9] !== t3) {
    t4 = <div key={stepKey} className={QUICK_ACTION_BAR_CLASS}>{t3}</div>;
    $[8] = stepKey;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}